__turbopack_context__.v({
  "fullscreenChip": "UserInputToken-module__qXMwxq__fullscreenChip",
});
